import { EditorOptions } from '@tiptap/core';
import { ReactNode } from 'react';

export interface EditorProps {
  value?: string | null;
  onChange: (value: string) => void;
  onFocus?: () => unknown;
  onBlur?: () => unknown;
  maxContentWidth?: number;
  maxImageWidth?: number;
  options?: {
    headings?: (1 | 2 | 3)[];
    button?: boolean;
    horizontalRule?: boolean;
    image?: boolean;
    placeholder?: string;
  };
  brandColor?: string | null;
  variables?: string[];
  translateButton?: (compact: boolean, disabled: boolean) => ReactNode;
  stickyMenuBar?: boolean;
  attributes?: EditorOptions['editorProps']['attributes'];
  generateContent?: () => unknown;
  generatingContent?: boolean;
  disabled?: boolean;
}

export const editorOptions: Record<'full', Partial<EditorProps['options']>> = {
  full: {
    headings: [1, 2, 3],
    button: true,
    horizontalRule: true,
    image: true,
  },
};
